import { connect } from 'react-redux'
import { reduxForm, change } from 'redux-form'
import Form from './Form.jsx'
import {profileSelector, handleProfileUpdateRequest, updateProfile, isTeacherOrganisationSelector} from '../../modules/profile'
import {languagesSelector} from '../../modules/app'
import validate from './validate'
import { showModalPayment } from '../../redux/actions.js'


const formName = 'profile'

let FormContainer = reduxForm({
    form: formName,
    onSubmit : (values, dispatch) => {
        let {"first-name" : firstname, "last-name" : lastname, gender, language : language_id, password : current_password, "new-password" : new_password, "confirm-password" : confirm_password} = values

        return handleProfileUpdateRequest({
            firstname : firstname.trim(),
            lastname : lastname.trim(),
            gender,
            language_id,
            current_password,
            new_password,
            confirm_password,
        })
            .then(updateData => {
                dispatch(updateProfile(updateData))
            })
            .then(() => {
                dispatch(change(formName, "first-name", firstname.trim()))
                dispatch(change(formName, "last-name", lastname.trim()))
            })
    },
    validate,
})(Form)

FormContainer = connect(
    state => {
        let {username, firstname, lastname, gender, language_id, email, payment_date_active, is_organisation} = profileSelector(state)
        return {
            initialValues : {
                "first-name" : firstname,
                "last-name" : lastname,
                gender : gender + '',
                language : language_id,
                timezone : "0", // TODO temp before realization REST API on backend
            },
            username,
            email,
            payment_date_active,
            is_organisation,
            languages : languagesSelector(state),
            isTeacherOrganisation: isTeacherOrganisationSelector(state),
        }
    }, {
        showModalPayment
    }
)(FormContainer)

export default FormContainer


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Profile/Form.js